import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { FilterableMultiSelectDropdownComponent } from './filterable-multi-select-dropdown.component';

@NgModule({
  declarations: [FilterableMultiSelectDropdownComponent],
  imports: [CommonModule],
  exports: [FilterableMultiSelectDropdownComponent]
})
export class FilterableMultiSelectDropdownModule {}
